// hooks/useHeader.js
import { useState, useEffect } from 'react';
import { getsolutions } from '../services/solutionsapi';
let cachedData = null;

const useSolutions = () => {
  const [solution, setsolution] = useState(cachedData || []); 
  const [loading, setLoading] = useState(!cachedData);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!cachedData) {
    const fetchData = async () => {
      try {
        const data = await getsolutions();
        cachedData = data; 
        setsolution(data);
      } catch (err) {
        console.error('Error fetching menu:', err); 
        setError('Failed to fetch menu'); 
      } finally {
        setLoading(false); 
      }
    };

    fetchData();
  }
  }, []);

  return { solution, loading, error };
};

export default useSolutions;
